/**
 * 악덕알리미 연결 페이지 (/m/relation/devil · /m/relation/devil/app) — 햄버거 '악덕업자' 메뉴의 목적지.
 *
 * 설치 여부는 앱에 묻는다($j.F.App.devilAppInstalled = openApp check:1) → data-state 로 칩·버튼을 바꾼다.
 * 화면에 돌아올 때(visibilitychange — 스토어·브라우저에서 복귀)마다 다시 묻는다(기획 시안의 onResume 재확인).
 *   [악덕알리미 열기]      → openDevilApp()                        앱이 열린다
 *   [설치하러 가기]        → openDevilApp({fallback: /devil-install}) 앱이 없으니 안내 웹을 외부 브라우저로
 * 구앱은 설치 여부를 알 수 없다(data-state=web) → [설치하러 가기]만 보이고, 누르면 안내 웹으로 이동한다.
 * PC 브라우저(앱 아님, data-state=pc)는 폰에 설치할 게 없으니 버튼 없이 소개만 보인다.
 */
export default class RelationDevilApp {
    initialize() {
        this.$root = $('#dvaRoot');
        if (!this.$root.length) return;

        $('#dvaCtaOpen').on('click', () => this.onClickOpen());
        $('#dvaCtaInstall').on('click', () => this.onClickInstall());

        this._onVisible = () => { if (!document.hidden) this.refresh(); };
        document.addEventListener('visibilitychange', this._onVisible);

        this.refresh();
    }

    /** 설치 여부를 앱에 물어 칩·버튼 갱신. 알 수 없으면 구앱 web / 브라우저 pc */
    refresh() {
        const installed = $j.F.App.devilAppInstalled();
        const state = installed === null ? (window.App ? 'web' : 'pc') : (installed ? 'ok' : 'no');
        this.$root.attr('data-state', state);
    }

    onClickOpen() {
        const r = $j.F.App.openDevilApp();
        if (r !== 'opened') this.refresh();     // 그새 지워졌으면 '설치 전'으로
    }

    onClickInstall() {
        const fallback = location.origin + '/devil-install';
        const r = $j.F.App.openDevilApp({ fallback });
        if (r === false) { location.href = fallback; return; }   // 구앱 — 안내 웹을 이 창에서
        if (r === 'opened') this.refresh();     // 그새 설치됐으면 앱이 열린다 → '설치돼 있어요'로
    }

    destroy() {
        if (this._onVisible) document.removeEventListener('visibilitychange', this._onVisible);
    }
}
